import { Outlet } from "react-router-dom"

import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar"
import { Separator } from "@/components/ui/separator"
import { ThemeToggle } from "@/components/theme-toggle"
import { AppSidebar } from "@/layouts/components/app-sidebar"
import { LanguageToggle } from "@/components/language-toggle"

export function DashboardLayout() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="min-w-0">
        <header className="sticky top-0 z-10 flex h-14 items-center gap-2 border-b bg-card px-4">
          <SidebarTrigger />
          <Separator orientation="vertical" className="h-full" />
          <div className="ml-auto">
            <LanguageToggle />
            <ThemeToggle />
          </div>
        </header>
        <main className="min-w-0 flex-1 bg-[#F9FAFC] p-6 dark:bg-background">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  )
}
